module.exports = __webpack_public_path__ + "img/psycwave.49b48b40.webp";